module.exports = __webpack_public_path__ + "static/media/add_members.98d0d22c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/fiduciaria_flow_7/img/add_members.png
 ** module id = 1431
 ** module chunks = 0
 **/